import Image from 'next/image'
import type { FunctionComponent } from 'react'

import styles from './review.module.scss'
import { StarRating } from '@components/star-rating'
import { Text } from '@components/text'
import type { ReviewFragment } from '@graphql/fragments/ReviewFragment.graphql'
import { TEXT } from '@lib/utils/text'

const FeatureReview: FunctionComponent<Props> = ({
    title,
    source,
    text,
    rating,
    author,
}) => {
    return (
        <div className={styles['feature-review']}>
            <div className={styles.inner}>
                <Text
                    tag='div'
                    typeStyle='body-lg'
                    bold
                    className={styles.title}
                >
                    {title}
                </Text>
                <Text tag='div' typeStyle='body-xs' className={styles.text}>
                    {text}
                </Text>
                <div className={styles['author-row']}>
                    <Text
                        tag='div'
                        typeStyle='body-2xs'
                        className={styles.author}
                    >
                        {author}
                    </Text>
                    {rating && (
                        <div className={styles.rating}>
                            <StarRating
                                value={rating}
                                color='step-cyanora'
                                starSize='xsmall'
                            />
                        </div>
                    )}
                </div>
            </div>
            {source?.logo?.svgSource && (
                <div
                    className={styles['source-row']}
                    data-testid='section.feature.review.source'
                >
                    <Text
                        tag='div'
                        typeStyle='body-xs'
                        color='dim'
                        className={styles.source}
                    >
                        {TEXT.asSeenOn}
                    </Text>
                    <div className={styles.logo}>
                        <Image
                            src={source.logo.svgSource}
                            alt={source.title ?? ''}
                            width={source.logo.width}
                            height={source.logo.height}
                        />
                    </div>
                </div>
            )}
        </div>
    )
}

export default FeatureReview

type Props = ReviewFragment
